import React, { useState } from 'react';
import { PinChangeDialog } from './PinChangeDialog';

export const PinChangeMenuHandler = () => {
  const [isPinChangeOpen, setIsPinChangeOpen] = useState(false);
  const [isForced, setIsForced] = useState(false);

  // Listen for PIN change menu action
  React.useEffect(() => {
    const handleChangePinAction = () => {
      setIsPinChangeOpen(true);
      setIsForced(false);
    };

    const handleForceChangePinAction = () => {
      setIsPinChangeOpen(true);
      setIsForced(true);
    };

    window.addEventListener('changePinAction', handleChangePinAction);
    window.addEventListener('forceChangePinAction', handleForceChangePinAction);
    
    return () => {
      window.removeEventListener('changePinAction', handleChangePinAction);
      window.removeEventListener('forceChangePinAction', handleForceChangePinAction);
    };
  }, []);

  const handleOpenChange = (open: boolean) => {
    // Prevent closing if forced mode is active
    if (isForced && !open) {
      return;
    }
    setIsPinChangeOpen(open);
    if (!open) {
      setIsForced(false);
    }
  };

  return (
    <PinChangeDialog 
      open={isPinChangeOpen} 
      onOpenChange={handleOpenChange}
      forced={isForced}
    />
  );
};